import React from 'react';
import PaymentRefund from './PaymentRefund';

const PaymentRefundRoute = () => {
  return <PaymentRefund />;
};

export default PaymentRefundRoute;